import { useEffect } from 'react';
import NProgress from 'nprogress';
export var useProgressBar = function useProgressBar(_ref) {
  var pathname = _ref.pathname;
  useEffect(function () {
    NProgress.start();
    return function () {
      NProgress.done();
    };
  }, [pathname]);
};